interface NotFoundProps {
	redirectLink?: string;
}

const NotFound = ({ redirectLink = '/' }: NotFoundProps) => {
	return (
		<div
			className="bay-error-page row vh-100 d-flex justify-content-center align-content-center"
			style={{
				backgroundImage: 'url(\'http://bay.cdn.bkat.io/www/Wave.png\')',
				backgroundSize: 'cover',
				paddingTop: 0,
			}}
		>
			<div className="col-12 text-center">
				<h1>
					Error <span className="text-pink">404</span>
				</h1>
				<p className="my-4 h2">
					Sorry this page was not found.
					<br />
					Our team has been flagged and will be looking into it.
				</p>
				<a className="btn text-light bg-pink-500" href={redirectLink}>
					Back To Home
				</a>
			</div>
		</div>
	);
};

export default NotFound;
